import styled from 'styled-components';
import { COLORS } from '@/styles/colors';

export const Separator = styled.div`
  width: 100%;
  margin: 12px 0 20px;
  border-top: 1px solid ${COLORS.grey[400]};
`;
